export default "__VITE_ASSET__c39172e4__"